// extracted by mini-css-extract-plugin
export default {"cardHeader":"Customer_cardHeader__PMGf-","card":"Customer_card__J6Pq3","tabContent":"Customer_tabContent__+ou6T","navTabs":"Customer_navTabs__eHEL1"};